import * as React from "react";
import { IError, getMessage } from "../services/errorService";

interface IErrorsProps {
    error?: IError;
}

function errors(props: IErrorsProps) {
    if (!!props.error) {
        const errorMessage = getMessage(props.error);
        return (
            <p className="text-error">{errorMessage}</p>
        );
    } else {
        return null;
    }
}

export const Errors = errors;


// WEBPACK FOOTER //
// ./src/components/errors.tsx